import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { CustomPopup, LoadingBox } from "component/basic/popup";
import { BtnBox, BtnItem } from "component/basic/btns";
import { InputItemBox } from "component/basic/formItems";
import { comFormat } from "js/function";
import { FixedPage, FixedSection } from "component/basic";
import { NotItems } from "component/basic/notItems";
import { PointFixedTap, Tap } from "component/basic/tap";
import { CouponPackItem, FixedContents } from "component/product/page";
import { MypageBasicListItem, MypageContentsBox, MypageControll, MypageCountBox, PageContentsSection } from "component/mypage/items";

const Coupon = (props) => {
    const navigate = useNavigate();

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);
    const [category,setCategory] =  useState(1);

    const [addCouponPopupData,setAddCouponPopupData] =  useState(null);
    const [useCouponPopupData,setUseCouponPopupData] =  useState(null);

    const [couponNumber,setCouponNumber] =  useState("");

    const [submitChk,setSubmitChk] =  useState(true);

    const pageDataApi = useGet({
        url:`/coupon${category ? `?status=${category}` : ""}`,
        loginType:"login"
    });
    const coupon_count = pageDataApi?.data?.coupon_count;
    const pageData = pageDataApi?.data?.coupons;

    function addCoupon(){
        if(submitChk){
            setSubmitChk(false);
            setLoadingBoxOpen(true);
        
            let formData = new FormData();
            formData.append("code", couponNumber);
        
            fatchSet.FatchApi({
                type:"POST",
                formDataItem: formData,
                loginType: "login",
                url: `/coupon/register`,
                success: (apiData) => {
                    setSubmitChk(true);
                    setLoadingBoxOpen(false);

                    window.errPopupOpen({
                        alert:`쿠폰 등록 완료`,
                        data:`쿠폰이 등록되었습니다.<br/>지금 바로 쿠폰함을 확인해보세요!`,
                        closeType:false,
                        func:()=>{
                            setCouponNumber("");
                            setAddCouponPopupData(null);
                        }
                    });
                },
                err: (apiData) => {
                    setSubmitChk(true);
                    if(apiData?.data || apiData?.alert){
                        window.errPopupOpen(apiData);
                    }
                    setLoadingBoxOpen(false);
                }
            })
        }
    }

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg mTapContents"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={"쿠폰 내역"}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={4}
                    closeFunc={()=>{}}
                />
                <FixedPage addClass="reverse mnReverse">
                    <FixedSection
                        pageBox="pageSizing"
                        boxAddClass="fixedsection_min pcItemT"
                        addClass="nonFixed fixedsection_min"
                        contentsBox="fixedPage"
                        nonFixed={true}
                        headerChk={true}
                        footerChk={true}
                        minSize={961}
                    >
                        <MypageControll
                            addClass="pcItemT"
                            data={null}
                        />
                    </FixedSection>
                    <FixedContents addClass="mypageFixedContents">
                        <PageTitle
                            addClass="fixedContents_title pcItemT"
                            pageBack={null}
                            contents="쿠폰 내역"
                        >
                            <Tap
                                addClass="underLine"
                                data={[
                                    {
                                        id:1,
                                        name:"사용 가능"
                                    },
                                    {
                                        id:"company",
                                        name:"제휴사 쿠폰"
                                    },
                                    {
                                        id:2,
                                        name:"사용 완료/만료"
                                    }
                                ]}
                                nameKey={"name"}
                                valKey={"id"}
                                nameCaption={null}
                                val={category}
                                allText={null}
                                func={(name,val)=>{setCategory(val)}}
                            />
                        </PageTitle>
                        <PointFixedTap
                            boxAddClass={"mItemT row"}
                            headerTap={true}
                            headerChk={true}
                            addClass=""

                            data={[
                                {
                                    id:1,
                                    name:"사용 가능"
                                },
                                {
                                    id:"company",
                                    name:"제휴사 쿠폰"
                                },
                                {
                                    id:2,
                                    name:"사용 완료/만료"
                                }
                            ]}
                            nameKey={"name"}
                            valKey={"id"}
                            nameCaption={null}
                            val={category}
                            allText={null}
                            func={(name,val)=>{setCategory(val)}}
                        />
                        <MypageCountBox
                            type="coupon"
                            title="보유 쿠폰"
                            val={comFormat(coupon_count||"0")}
                            unit="개"
                            func={()=>{
                                setAddCouponPopupData({
                                    addClass:"subTitle_line_1",
                                    title:"쿠폰 등록하기",
                                    subTitle:"등록할 쿠폰 번호를 입력해주세요.",
                                    closeType:true,
                                    closeFunc:(e) => {setAddCouponPopupData(null);setCouponNumber("")},
                                    closeBtnDel:true
                                });
                            }}
                        />
                        <PageContentsSection addClass="">
                            {pageData && pageData?.length > 0 ? 
                                <MypageContentsBox
                                    nPadding={true}
                                    title={null}
                                >
                                    {pageData && pageData?.map((item, i) => (
                                        <MypageBasicListItem
                                            key={i}
                                            type={"coupon"}
                                            status={item.status}
                                            image_url={item.image_url}
                                            coupon_type={item.coupon_type}
                                            discount_value={item.discount_value}
                                            discount_type={item.discount_type}
                                            company_name={item.company_name}
                                            name={item.name}
                                            use_condition={item.use_condition}
                                            use_condition_value={item.use_condition_value}
                                            end_date={item.end_date}
                                            func={()=>{
                                                setUseCouponPopupData({
                                                    addClass:"subTitle_line_1",
                                                    title:"제휴사 쿠폰 사용",
                                                    subTitle:"아래 바코드 이미지를 매장 직원분에게 보여주세요",
                                                    closeType:true,
                                                    closeFunc:(e) => {setUseCouponPopupData(null)},
                                                    closeBtnDel:true,
                                                    couponData:item
                                                });
                                            }}
                                        />
                                    ))}
                                </MypageContentsBox>
                            :
                                <NotItems addClass="fullPage" text={`쿠폰 내역이 없습니다.`}/>
                            }
                        </PageContentsSection>
                    </FixedContents>
                </FixedPage>
            </ContentsSection>
            <Footer/>
            <CustomPopup data={addCouponPopupData} toastType={true}>
                <InputItemBox
                    inputType={null}
                    addClass=""
                    inputName="쿠폰번호"
                    placeholder="등록할 쿠폰 번호 입력"
                    value={couponNumber}
                    max={20}
                    regexp={null}
                    func={(value)=>{setCouponNumber(value)}}
                />
                <BtnBox
                    boxType="fixed"
                    addClass="col2"
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"취소"}
                        func={() => {
                            setCouponNumber("");
                            setAddCouponPopupData(null);
                        }}
                    />
                    <BtnItem
                        addClass=""
                        contents={"쿠폰 등록"}
                        disabled={couponNumber?.length > 0 ? false : true}
                        func={() => {addCoupon()}}
                    />
                </BtnBox>
            </CustomPopup>
            <CustomPopup data={useCouponPopupData} toastType={true}>
                <CouponPackItem
                    addClass="useCouponPackItem"
                    name={useCouponPopupData?.couponData?.company_name}
                    couponImg={null}
                    barcode_image={useCouponPopupData?.couponData?.barcode_image}
                />
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass="subColor"
                        contents={"확인"}
                        disabled={false}
                        func={() => {
                            setUseCouponPopupData(null);
                        }}
                    />
                </BtnBox>
            </CustomPopup>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default Coupon;